import React from 'react'
import './plot.css'

class Plot extends React.PureComponent {

  render() {
    const {className, content} = this.props
    const classNames = ['content-plot']
    if (className) {
      classNames.push(className)
    }
    return (
      <div className={classNames.join(' ')}>
        <div
          dangerouslySetInnerHTML={ {
            __html: content
          }}
        />
      </div>
    )
  }
}

export default Plot



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/plot/Plot.js